import allCopies from './copies'

let languages = [
  'es',
  'pt'
]

let copies = {}

function setCopies (language) {
  Object.keys(allCopies.copies).forEach(function (key) {
    copies[key] = allCopies.copies[key][language]
  })
}

function getCopy (key) {
  return copies[key] || key
}

export default {
  languages,
  copies,
  setCopies,
  getCopy
}



// WEBPACK FOOTER //
// ./src/constants.js